import "tailwindcss/dist/base.css";
import "styles/globalStyles.css";
import React from "react";
import { css } from "styled-components/macro"; //eslint-disable-line

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import MainLandingPage from './pages/MainLandingPage';
import AboutProject from "pages/AboutProject";
import ContactUs from "pages/ContactUs";
import EducationalInstitutes from "pages/EducationalInstitutes";
import DownloadApp from "pages/DownloadApp";

function App() {
  // If you want to disable the animation just use the disabled `prop` like below on your page's component
  // return <AnimationRevealPage disabled>xxxxxxxxxx</AnimationRevealPage>;

  return (
    <Router>
      <Switch>
        <Route path="/contact-us">
          <ContactUs />
        </Route>
        <Route path="/educational-institutes">
          <EducationalInstitutes />
        </Route>
        <Route path="/about-project">
          <AboutProject />
        </Route>
        <Route path="/download-app">
          <DownloadApp />
        </Route>
        <Route path="/">
          <MainLandingPage />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
